import { render, staticRenderFns } from "./selectMaterial.vue?vue&type=template&id=f34ba5d6&scoped=true"
import script from "./selectMaterial.vue?vue&type=script&lang=js"
export * from "./selectMaterial.vue?vue&type=script&lang=js"
import style0 from "./selectMaterial.vue?vue&type=style&index=0&id=f34ba5d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f34ba5d6",
  null
  
)

export default component.exports